import { createElement } from 'react';

import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';

import { AiReadinessIcon } from './AiReadinessIcon';
import { AiReadinessClient, aiReadinessApiRef } from './api';
import { rootRouteRef } from './routes';

const aiReadinessApi = ApiBlueprint.make({
  name: 'ai-readiness',
  params: defineParams =>
    defineParams({
      api: aiReadinessApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiReadinessClient({ discoveryApi, fetchApi }),
    }),
});

const aiReadinessPage = PageBlueprint.make({
  name: 'ai-readiness',
  params: {
    path: '/ai-readiness',
    title: 'AI Readiness',
    icon: createElement(AiReadinessIcon),
    routeRef: rootRouteRef,
    loader: async () => {
      const { AiReadinessPage } = await import('./components/AiReadinessPage');
      return createElement(AiReadinessPage);
    },
  },
});

export const aiReadinessPlugin = createFrontendPlugin({
  pluginId: 'ai-readiness-frontend',
  extensions: [aiReadinessApi, aiReadinessPage],
  routes: { root: rootRouteRef },
});
